<form [formGroup]="formData" *ngIf="formData">
  <div matDialogTitle class="modal-header">
    <h2>
      <button style="float: left" mat-dialog-close aria-label="Close dialog" title="סגור ללא שמירה" class="btn btn-circle.btn-lg">
        <i class="fa fa-times"></i>
      </button>
      סנכרון QuickBooks
      <br>
      <small>סנכרון איש קשר בודד עם בדיקת Class לפי מצב נוכחי</small>
    </h2>
  </div>

  <div mat-dialog-content class="p-24">
    <div class="form-group">
      <label>מתאריך:</label>
      <date-input [dateControl]="formData.controls.minimumPaymentDate"></date-input>
    </div>

    <div class="form-group">
      <mat-slide-toggle formControlName="includeFuturePayments">כלול תשלומים עתידיים</mat-slide-toggle>
    </div>

    <div class="form-group">
      <mat-slide-toggle formControlName="includeNonSuccessfulPayments">כלול תשלומים לא מוצלחים</mat-slide-toggle>
    </div>
  </div>

  <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">
    <button mat-button (click)="onNoClick()">ביטול</button>
    <button mat-button [mat-dialog-close]="formData" [disabled]="formData.invalid">סנכרן</button>
  </div>
</form>
